import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {WorkflowService} from "../workflow.service";
import {DeviceRelocationService} from "../../device-relocation/device-relocation.service";
import {DeviceRelocationModel} from "../../device-relocation/device-relocation.model";
import {DeviceRelocationWorkflowService} from "./device-relocation-workflow.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {handleErrors} from "../../misc/handle-errors.decorator";

@Component({
  templateUrl: "./device-relocation-details.template.pug",
  providers: [
    DeviceRelocationService,
    DeviceRelocationWorkflowService,
  ],
})
export class DeviceRelocationDetails extends WorkflowStep {
  deviceRelocationId: string;
  siteId: string;
  deviceRelocationName: string;
  deviceRelocationForm: FormGroup = new FormGroup({name: new FormControl("", [Validators.required])});
  error: Error;

  @handleErrors()
  async ready(): Promise<void> {
    this.deviceRelocationId = this.workflowService.workflowConfig.targetId;

    const relocation = await this.deviceRelocationService.getDeviceRelocationById(this.deviceRelocationId);
    this.deviceRelocationForm = new FormGroup({
      name: new FormControl({value: relocation.name, disabled: relocation.closed}, [Validators.required]),
    });

    this.siteId = relocation.siteId;
  }

  constructor(
    private deviceRelocationService: DeviceRelocationService,
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private deviceRelocationWorkflowService: DeviceRelocationWorkflowService,
  ) {
    super();
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    await this.deviceRelocationWorkflowService.updateRelocationDetails({
      id: this.deviceRelocationId,
      siteId: this.siteId,
      name: this.deviceRelocationForm.controls["name"].value,
    } as DeviceRelocationModel);

    this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }

  checkDirty(): boolean {
    return this.deviceRelocationForm.dirty || this.deviceRelocationForm.invalid;
  }
}
